import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { decode } from 'html-entities';
import linkifyHtml from 'linkify-html';
import { forwardRef, useMemo } from 'react';
import { highlightSearchKeyword } from 'utility/helpers';

type RenderInsightDescriptionProps = {
  description: string;
  searchKeyword: string;
};

function RenderInsightDescription({ description, searchKeyword }, descriptionRef) {
  const _description = useMemo(
    () => highlightSearchKeyword(description, searchKeyword),
    [description, searchKeyword],
  );

  return (
    <ArticleDescription
      ref={descriptionRef}
      dangerouslySetInnerHTML={{ __html: linkifyHtml(decode(_description), { target: '_blank' }) }}
      sx={{
        '& img, table': {
          display: 'none',
        },
      }}
    />
  );
}

const ArticleDescription = styled(Typography, { label: 'ArticleDescription' })(({ theme }) => ({
  position: 'relative',
  wordBreak: 'break-word',
  fontFamily: 'Lato, sans-serif',
  fontSize: 16,
  color: theme.palette.custom.black,
  '& *': {
    fontFamily: 'Lato, sans-serif !important',
  },
  '&.short *, &.list *, &.draft *, &.related-post *': {
    maxHeight: 100,
  },
  '& .highlight': {
    backgroundColor: 'yellow !important',
  },
  '& a': {
    whiteSpace: 'pre-wrap',
    color: `${theme.palette.custom.link} !important`,
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
  '&.related-post': {
    lineHeight: '20px',
    paddingTop: 4,
    fontSize: 14,
  },
}));

export default forwardRef<HTMLDivElement, RenderInsightDescriptionProps>(RenderInsightDescription);
